"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _friendlyPropertyName;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var groupOperators = exports.groupOperators = {
  BOOLEAN: "boolean"
};

var groupOperatorValues = exports.groupOperatorValues = {
  AND: "and",
  OR: "or"
};

var conditionNames = exports.conditionNames = {
  URL: "url",
  DOMAINS: "domains",
  PROPERTIES: "properties",
  LANGUAGES: "languages",
  MOBILE_CONTENT: "mobile_content",
  CONTENT: "content",
  EVENT: "event",
  SEGMENTS: "segments",
  FREQUENCY: "frequency",
  TRIGGER: "trigger",
  ATTRIBUTES: "attributes"
};

var frequencyValues = exports.frequencyValues = {
  ONCE: "once",
  EVERYTIME: "every_time",
  NEVER: "never"
};

var propertyConditionNames = exports.propertyConditionNames = {
  PROPERTIES: conditionNames.PROPERTIES,
  LANGUAGES: conditionNames.LANGUAGES,
  CONTENT: conditionNames.CONTENT,
  MOBILE_CONTENT: conditionNames.MOBILE_CONTENT,
  EVENT: conditionNames.EVENT,
  SEGMENTS: conditionNames.SEGMENTS
};

var propertyOperators = exports.propertyOperators = {
  EQUALS: "==",
  NOT_EQUALS: "!=",
  GREATER_THAN: ">",
  LESS_THAN: "<",
  CONTAINS: "*",
  NOT_CONTAINS: "!*",
  STARTS_WITH: "^",
  NOT_STARTS_WITH: "!^",
  ENDS_WITH: "$",
  NOT_ENDS_WITH: "!$",
  EXISTS: "?",
  NOT_EXISTS: "!?",
  IN: "in",
  NOT_IN: "not in",
  SINCE: "since",
  GREATER_THAN_X_DAYS_AGO: "> ago",
  LESS_THAN_X_DAYS_AGO: "< ago",
  WITHIN_X_DAYS_AGO: "within",
  GREATER_THAN_TIME: "> time",
  LESS_THAN_TIME: "< time",
  REGEX: "regex"
};

var negatedOperators = exports.negatedOperators = [propertyOperators.NOT_STARTS_WITH, propertyOperators.NOT_ENDS_WITH, propertyOperators.NOT_CONTAINS, propertyOperators.NOT_EQUALS];

/**
 * Whitelist of valid JSON keys in a nested conditions tree
 *
 * @type {[string]}
 */

var clauseKeys = exports.clauseKeys = ["operator", "value", "property", "content", "mobile_content", "times", "since", "event", "segment", "attributes", "attribute", "conditions"];

var defaultOperators = exports.defaultOperators = {
  STARTS_WITH: propertyOperators.STARTS_WITH,
  NOT_STARTS_WITH: propertyOperators.NOT_STARTS_WITH,
  ENDS_WITH: propertyOperators.ENDS_WITH,
  NOT_ENDS_WITH: propertyOperators.NOT_ENDS_WITH,
  CONTAINS: propertyOperators.CONTAINS,
  NOT_CONTAINS: propertyOperators.NOT_CONTAINS,
  EXACT: propertyOperators.EQUALS,
  NOT_EXACT: propertyOperators.NOT_EQUALS,
  REGEX: propertyOperators.REGEX
};

var millisecondsPerDay = exports.millisecondsPerDay = 1000 * 60 * 60 * 24;

var friendlyPropertyNames = exports.friendlyPropertyNames = (_friendlyPropertyName = {}, _defineProperty(_friendlyPropertyName, conditionNames.URL, "path"), _defineProperty(_friendlyPropertyName, conditionNames.DOMAINS, "environment"), _defineProperty(_friendlyPropertyName, conditionNames.PROPERTIES, "property"), _defineProperty(_friendlyPropertyName, conditionNames.LANGUAGES, "language"), _defineProperty(_friendlyPropertyName, conditionNames.CONTENT, "step group"), _defineProperty(_friendlyPropertyName, conditionNames.EVENT, "event"), _defineProperty(_friendlyPropertyName, conditionNames.SEGMENTS, "segment"), _defineProperty(_friendlyPropertyName, conditionNames.FREQUENCY, "frequency"), _defineProperty(_friendlyPropertyName, conditionNames.MOBILE_CONTENT, "Mobile Flow"), _friendlyPropertyName);